<template>
  <section class="index">
    <div class="container">
      <div class="gc-page-container">
        <div class="container-center">
          <!-- <section class="gc-page">
            <div class="noQ">
              <div class="noQ-con">
                <div class="noQ-title">点击按钮进入问卷</div>
                <div class="noQ-button" @click="entryQuestion">进入问卷</div>
              </div>
              <Bulbs />
            </div>
          </section> -->
          <div class="shuomin">回答成功可获奖励金即时兑付，失败获10个点</div>
          <section class="gc-page-tmp">
            <div class="top-bg">
              <Bulbs txt="false" />
            </div>
            <a
              href="javascript:void(0)"
              class="bg-btn zhuan"
              @click="entryQuestion"
              >进入问卷</a
            >
            <p class="top-notice">当前奖励金标准为 {{ money }} 元</p>
          </section>

          <section class="gc-page">
            <div class="sub-content">
              <p>1. 当前奖励金标准为 {{ money }} 元</p>
              <p>2. 回答一次问卷会点亮一盏灯</p>
              <p>3. 每点亮一盏灯，奖励金标准会+1元</p>
              <p>
                4.
                5盏灯全亮进入大满贯模式，回答成功可保持，再次失败奖励金标准复原到2元
              </p>
            </div>
          </section>

          <section
            class="gc-page"
            v-for="(item, index) in listData"
            :key="item.ssiprid"
          >
            <!-- 已完成 -->
            <div class="gc-headImg-ctx">
              <img class="gc-headImg" src="../assets/img/cash.png" />
            </div>
            <div class="gc-page-top done">
              <div class="gc-money">{{ item.money }}<span>元</span></div>
              <div class="done-status">{{ item.status }}</div>
            </div>
            <div class="gc-page-center">
              <p class="gc-nickname">{{ item.ssiprid }}</p>
              <p class="gc-title">即付问卷</p>
              <!-- <p class="gc-subtitle">关于你的问卷调查</p> 创建时间： -->
            </div>
            <div class="gc-qrtime">{{ item.addtime }}</div>
            <div class="gc-qrcode">
              <div class="gc-qrcode-text" @click="showDetail(index)">详情</div>
            </div>
          </section>
        </div>
      </div>

      <card
        v-if="isShow"
        type="2"
        :dialog="dialog"
        @closeDialog="closeDialog"
        @tixianAgain="onTapTixianAgain"
      />
    </div>
  </section>
</template>

<script>
import Card from "../components/DialogCard";
import { getCookie } from "../utils";
import Bulbs from "../components/Bulbs";

export default {
  components: {
    Card,
    Bulbs
  },
  data() {
    return {
      isShow: false,
      listData: [],
      dialog: {},
      money: 2
    };
  },

  mounted() {
    this.requestDone();
    this.requsetNowLevel();
  },

  methods: {
    // 已完成
    requestDone() {
      let unionId = getCookie("unionId");
      this.$axios
        .get(
          "https://home.51point.com/51point-0.0.1-SNAPSHOT/distrionwj/getSsiCompletedListForPc",
          { params: { param: unionId } }
        )
        .then(res => {
          console.log("已完成");
          console.log(res);
          let list = [];
          res.data.data.forEach(item => {
            let value = {};
            value.addtime = item.addtime;
            value.failmsg = item.failmsg;
            value.id = item.id;
            value.money = item.money;
            value.openid = item.openid;
            value.orderno = item.orderno;
            value.ssiprid = item.ssiprid;
            value.unionid = item.unionid;
            value.updatetime = item.updatetime;
            if (item.status == 0) {
              value.status = "已申请";
            } else if (item.status == 1) {
              value.status = "已提现";
            } else {
              value.status = "已失效";
            }

            list.push(value);
          });
          this.listData = list;
        });
    },

    // 弹窗详情
    showDetail(index) {
      let unionId = getCookie("unionId");
      this.$axios
        .get(
          "https://home.51point.com/51point-0.0.1-SNAPSHOT/distrionwj/getSsiCompletedDetailForPc",
          { params: { param: unionId, pid: this.listData[index].ssiprid } }
        )
        .then(res => {
          console.log(res);
          this.dialog = res.data.data;
          this.dialog.prId = this.listData[index].ssiprid;
          this.isShow = true;
        });
    },

    // 进入问卷
    entryQuestion() {
      let unionId = getCookie("unionId");
      this.$axios
        .get(
          "https://home.51point.com/51point-0.0.1-SNAPSHOT/distrionwj/getSsiQuestionnaireForPc",
          { params: { param: unionId } }
        )
        .then(res => {
          console.log(res);
          if (res.data.data.link) {
            //  window.open(res.data.data.link);
            window.location.href = res.data.data.link;
          }
        });
    },

    closeDialog() {
      this.isShow = false;
    },

    // 再次体现
    onTapTixianAgain() {
      let unionId = getCookie("unionId");
      this.$axios
        .get(
          "https://home.51point.com/51point-0.0.1-SNAPSHOT/distrionwj/updateSForPc",
          {
            params: { param: unionId, i: this.dialog.prId }
          }
        )
        .then(res => {
          this.$axios
            .get(
              "https://home.51point.com/51point-0.0.1-SNAPSHOT/distrionwj/getSsiCompletedDetailForPc",
              { params: { param: unionId, pid: this.dialog.prId } }
            )
            .then(res => {
              console.log(res);
              this.dialog = res.data.data;
              this.isShow = true;
            });
        });
    },

    requsetNowLevel() {
      let unionId = getCookie("unionId");
      this.axios
        .get(
          "https://home.51point.com/51point-0.0.1-SNAPSHOT/challengelevel/getChallengeLevelForPc",
          { params: { param: unionId } }
        )
        .then(res => {
          console.log(res);
          if (res.data.data && res.data.data.length > 0) {
            this.money = res.data.data[0].prnowlevel;
          } else {
            this.money = 2;
          }
        });
    }
  }
};
</script>

<style scoped>
.bulbs-content {
  margin: 0.5rem 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.index .gc-qrcode-img {
  width: 125px;
  height: 125px;
  margin: 20px auto;
}
.index .wxssk {
  font-size: 12px;
  color: #666666;
  text-align: center;
}
.index .gc-qrcode-ctx {
  width: 160px;
  height: 200px;
  background: #ffffff;
  border: 1px solid #efefef;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.08);
  border-radius: 2px;
}
.index .gc-qrcode {
  position: absolute;
  bottom: 20px;
  right: 15px;
}
.index .gc-qrcode-text {
  font-size: 13px;
  color: #959499;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  /* width: 60px; */
  padding-left: 10px;
  padding-right: 10px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  float: right;
  margin-top: 10px;
  cursor: pointer;
}
.index .gc-qrcode-text:hover {
  background: #c9c9ce;
  border-color: #c9c9ce;
  color: #fff;
}
.index .gc-page {
  float: left;
  /* margin-right: 20px; */
  margin-left: 10px;
  margin-right: 10px;
}
.index .gc-category {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 2;
  border-radius: 100px;
  background-color: rgba(0, 0, 0, 0.7);
  font-size: 11px;
  color: #ffffff;
  padding: 5px;
}
.index .gc-page-bottom {
  position: absolute;
  bottom: 20px;
  z-index: 2;
  left: 15px;
  height: 16px;
  line-height: 16px;
  width: 150px;
  font-size: 12px;
  color: #9b9b9b;
}
.index .gc-headImg-ctx {
  position: absolute;
  top: 125px;
  left: 15px;
  z-index: 2;
  width: 32px;
  height: 32px;
}
.index .gc-headImg {
  width: 32px;
  height: 32px;
  border-radius: 32px;
  border: 2px solid #ffffff;
}
.index .gc-page-top {
  width: 280px;
  height: 140px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* justify-content: center; */
  justify-content: flex-end;
}

.index .gc-page-top img {
  width: 100%;
  height: 100%;
}

.index .gc-page-center {
  position: relative;
  padding: 15px;
  padding-top: 25px;
}
.index .gc-nickname {
  font-size: 13px;
  color: #666666;
  margin-bottom: 15px;
}
.index .gc-title {
  font-size: 15px;
  color: #333;
  margin-bottom: 12px;
  line-height: 22px;
}
.index .gc-subtitle {
  font-size: 12px;
  color: #888888;
  line-height: 18px;
  /* max-height: 54px; */
  overflow: hidden;
}

.index .notice-subtitle {
  font-size: 12px;
  color: #65ae71;
  line-height: 18px;
  max-height: 54px;
  overflow: hidden;
}
.index .notice-subtitle .big {
  font-size: 18px;
}
.index .gc-page {
  width: 280px;
  height: 360px;
  background: #ffffff;
  /* cursor: pointer; */
  position: relative;
  margin-bottom: 20px;
}
.index .gc-page:hover {
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.08);
}

.mar-top {
  margin-top: 20px;
}

.noQ {
  display: block;
  padding-top: 20px;
}

.noQ p {
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 28px;
}

.noQ-div {
  width: 260px;
  height: 196.48px;
  margin: 0 auto;
  background-size: 360px 196.48px;
  padding-top: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.noQ .noQ-link {
  color: #65ae71;
  border-bottom: 3px double #65ae71;
}

.index .gc-qrtime {
  position: absolute;
  bottom: 20px;
  left: 15px;
  font-size: 10px;
  color: #999;
}

.done {
  background: #9fc2e2;
}

.ing {
  background: #d4b7b5;
}

.done-status {
  /* position: relative;
  left: 105px;
  top: 8px; */
  /* width: 280px;
  height: 360px; */
  color: white;
  display: flex;
  flex-direction: row-reverse;
  margin-right: 5px;
  margin-bottom: 5px;
}

.ing-status {
  position: relative;
  left: 115px;
  top: 110px;
  color: white;
}

.ing-status span {
  font-size: 160%;
  margin-right: 4px;
}

.noQ-title {
  font-size: 14px;
  color: #999;
  margin-top: 20px;
}

.noQ-button {
  width: 100px;
  height: 35px;
  background: #5dac5b;
  color: white;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  margin: 10px auto;
  cursor: pointer;
}

.noQ-con {
  text-align: center;
}

.gc-money {
  color: white;
  font-size: 80px;
  text-align: center;
  margin-bottom: -10px;
  /* font-weight: 545; */
}

.gc-money span {
  font-size: 20px;
  margin-left: 5px;
  /* font-weight: normal; */
}

.index .gc-page-tmp {
  float: left;
  /* margin-right: 20px; */
  margin-left: 10px;
  margin-right: 10px;
  width: 280px;
  height: 360px;
  background: #ffffff;
  position: relative;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.index .gc-page-tmp:hover {
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.08);
}

.top-bg {
  height: 50%;
  width: 100%;
  background: #c9cfbc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bg-btn {
  width: 90%;
  height: 45px;
  color: white;
  display: block;
  border-radius: 4px;
  font-size: 15px;
  line-height: 45px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.zhuan {
  background: #65ae71;
}

.exit {
  background: #f16754;
}

.top-point {
  font-size: 48px;
  color: white;
  margin-bottom: 30px;
}

.top-point span {
  font-size: 15px;
  margin-left: 5px;
}

.top-title {
  font-size: 14px;
  color: #fff;
  margin-left: 10px;
}

.top-title span {
  opacity: 0.5;
  font-size: 12px;
  margin-left: 10px;
  color: #fff;
}

.top-bottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}

.top-bottom img {
  height: 18px;
  width: 18px;
  margin-right: 10px;
}

.top-notice {
  font-size: 14px;
  color: #999;
  text-align: center;
  margin-top: 10px;
}

.sub-content {
  margin: 20px 20px;
  padding: 20px 20px;
}

.sub-content p {
  font-size: 12px;
  color: #666;
  line-height: 20px;
  letter-spacing: 0;
}

.index .container {
  min-height: 540px;
}

/*  */
.shuomin {
  color: #999;
  font-size: 14px;
  margin: 20px 0px;
  padding-left: 10px;
  width: calc(100% - 10px);
}

.gc-page-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 auto;
}

.index .container-center {
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}

/* 手机 */
@media screen and (max-width: 768px) {
  .index .container-center {
    width: 300px;
  }
}

/* Pad */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .index .container-center {
    width: 600px;
  }
}

/* 中屏幕电脑 */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .index .container-center {
    width: 900px;
  }
}

/* 大屏幕电脑 */
@media screen and (min-width: 1200px) {
  .index .container-center {
    width: 1200px;
  }
}
</style>
